import { useOktaAuth } from '@okta/okta-react'
import React, { useEffect, useState } from 'react'
import { useUserInfo } from '../../providers/userProvider'
import { getCampaigsByRn } from '../../services/campaign.service';
import queryString from 'query-string'
import { ERR_DESC_REQUEST_NUMBER, ERR_DESC_SURVEY_CODE, ERR_TITLE_REQUEST_NUMBER, ERR_TITLE_SURVEY_CODE} from '../../utils/errorLiterals';
import { CRS_SURVEY_CODES, SCBM_USER_TYPE} from '../../utils/surveyLiterals';
import { Redirect } from 'react-router-dom';
import { getSurveyById } from '../../services/survey.service';
import CM from '../cm/CMSurveyPage';
import {getDateFromTimeStamp} from '../../utils/utils'
import { useLocation } from 'react-router'

function isValidRN(rn) {
    return rn && rn.length <= 19 && !isNaN(rn) && Number.isInteger(parseFloat(rn));//Size in DB
}

function validationRules(respCampaign, userInfo) {
    let error;
    if (respCampaign) {
        let campaign = respCampaign;
        if (userInfo.userType !== SCBM_USER_TYPE.SALARY) {
            //it is normal user, we have to validate that the current user has the supplier
            if (!userInfo.suppliers || userInfo.suppliers.length <= 0
                || !userInfo.suppliers.includes(campaign.assignments[0].supplierNumber)) {
                error = 'No suppliers assigned';
            }//else everything is OK
        }//else Read only for the deere employee
    } else {//The assignment does not exist
        error = 'No campaing found';
    }
    return error;
}

export default function Home() {
    const actualURL = window.location.href;
    const { authState } = useOktaAuth();
    const userInfo = useUserInfo();
    const [campaignAssigned, setCampaignAssigned] = useState();
    const [containsError, setContainsError] = useState(false);
    const [survey, setSurvey] = useState(undefined);
    const location = useLocation();
    
    let value = queryString.parse(location.search);
    let rn = value.rn;

    const [nonOktaParams] = useState({
        previous: location && location.state && location.state.previous ? location.state.previous : "",
        queryParam: location && location.state && location.state.queryParam ? location.state.queryParam : "",
        isAuthNonOkta: location && location.state && location.state.isAuthNonOkta ? location.state.isAuthNonOkta : false,
    });
    if (nonOktaParams && nonOktaParams.previous === "/surveyLogin" && !rn) {
        rn = nonOktaParams.queryParam.toString();
    }
        
    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    let nonOktaAuthFailed = !isAuthMethodOkta ? (nonOktaParams && nonOktaParams.isAuthNonOkta ? false : true) : false;
    let token = isAuthMethodOkta ? authState.accessToken.accessToken : "";

    useEffect(() => {
        if ((!isAuthMethodOkta || userInfo) && rn && !campaignAssigned && isValidRN(rn)) {
            getCampaigsByRn(rn, token, isAuthMethodOkta)
                .then((res) => {
                    let errorValidation = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? false : validationRules(res, userInfo);
                   
                    if (errorValidation) { 
                        console.log(errorValidation);
                        setContainsError(true)
                    } else {
                         setCampaignAssigned(res);
                          
                    }
                }).catch(error => {
                    //Campaign not found
                    console.log(error);
                    setContainsError(true)
                })
        }
    }, [userInfo, campaignAssigned]);

    useEffect(() => {
        if (!survey && campaignAssigned && !containsError) {
            getSurveyById(campaignAssigned.surveyId, token, isAuthMethodOkta)
                .then((s) => {
                    s.endDate=getDateFromTimeStamp( campaignAssigned.endDate);
                    setSurvey(s);
                })
        }
    }, [survey, campaignAssigned])

    if (!rn || containsError || !isValidRN(rn) || (!isAuthMethodOkta && nonOktaAuthFailed)) {
        return <Redirect
                to={{    
                pathname: '/error',
                state: {errorTitle: ERR_TITLE_REQUEST_NUMBER,
                        errorDescription: ERR_DESC_REQUEST_NUMBER, 
                        errorUrl:actualURL,
                        errorUser: userInfo? userInfo.userID : ''}
                }}
            />
    }

    if ((isAuthMethodOkta && !userInfo) || !campaignAssigned || !survey) {
        return (<div>
            <h5>Loading...</h5>
        </div>)
    } else {
        switch(survey.code){
            case CRS_SURVEY_CODES.CM:
                return <CM survey={survey} campaignAssigned={campaignAssigned} isAuthMethodOkta={isAuthMethodOkta} token={token}/>
            default:
                return <Redirect
                            to={{
                            pathname: '/error',
                            state: {errorTitle: ERR_TITLE_SURVEY_CODE,
                                    errorDescription: ERR_DESC_SURVEY_CODE, 
                                    errorUrl:actualURL,
                                    errorUser: userInfo? userInfo.userID : ''}
                            }}
                        />
        }
    }
}